import React from 'react';
import { MdLibraryBooks } from "react-icons/md";

interface FeaturedResourceCardProps {
    title?: string;
    subtitle?: string;
    imageLink?: string;
    tag?: string;
}

const FeaturedResourceCard: React.FC<FeaturedResourceCardProps> = ({ title, subtitle, imageLink }) => {
    return (
        <div className='cursor-pointer'>
            <div className="max-w-xl w-full rounded overflow-hidden shadow-lg m-3 bg-custom-black text-white font-jarkarta flex">
                <div className="h-[200px] flex justify-center items-center bg-white overflow-hidden">
                    <img src={imageLink} alt={title || 'Resource Image'} className="object-cover h-full" />
                </div>
                <div className="flex-1 p-4 flex flex-col justify-between w-72">
                    <span className={`inline-block rounded-full py-1 text-gray-300 text-sm font-semibold mb-2`}>
                        Newest Releases
                    </span>
                    <div>
                        <h3 className="font-bold text-xl mb-2 hover:underline">
                            {title}
                        </h3>
                        {subtitle && <p className="text-base">{subtitle}</p>}
                    </div>
                    <div className='flex justify-end font-semibold items-center'>
                        <MdLibraryBooks className='text-xl' />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default FeaturedResourceCard;
